/* =====================================================================
 * MC Nutrition · Atelier theme · JS
 * Cart drawer toggle, FAQ accordion, peptide filters, candidacy modal.
 * Sections register their handlers via data attributes below.
 * ===================================================================== */

(function () {
  'use strict';

  // ── bfcache reset ────────────────────────────────────────────────────
  // When the browser restores this page from bfcache (e.g. clicking back
  // from a product page), the previously-filtered state can persist. Reset
  // the peptide grid filter to "All" so every card shows again.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-px-grid-root]').forEach(function (root) {
      const allBtn = root.querySelector('[data-px-filter="all"]');
      if (allBtn) allBtn.click();
    });
  });

  // ── Responsive shim ──────────────────────────────────────────────────
  // The design-system CSS uses `.c-atelier-page.mobile` selectors instead of
  // media queries. We toggle that class on the body so all those rules light
  // up automatically below 768px.
  function applyMobileClass() {
    document.body.classList.toggle('mobile', window.innerWidth <= 768);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMobileClass);
  } else {
    applyMobileClass();
  }
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyMobileClass, 100);
  });

  // ── FAQ accordion ────────────────────────────────────────────────────
  // Markup: <button class="pp-faq-q" aria-expanded="false" aria-controls="faq-1">…</button>
  //         <div class="pp-faq-a" id="faq-1" hidden>…</div>
  document.addEventListener('click', function (e) {
    const q = e.target.closest('.pp-faq-q');
    if (!q) return;
    const id = q.getAttribute('aria-controls');
    if (!id) return;
    const a = document.getElementById(id);
    if (!a) return;
    const open = q.getAttribute('aria-expanded') === 'true';
    q.setAttribute('aria-expanded', String(!open));
    a.hidden = open;
    const toggle = q.querySelector('.pp-faq-q-toggle');
    if (toggle) toggle.textContent = open ? '+' : '–';
  });

  // ── Peptide filters ──────────────────────────────────────────────────
  // Markup: <button class="px-filter" data-px-filter="all|gut|weight|…">All</button>
  //         <a class="px-grid-item" data-px-categories="gut,brain,…">…</a>
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-px-filter]');
    if (!btn) return;
    const filter = btn.getAttribute('data-px-filter');
    const grid = btn.closest('[data-px-grid-root]') || document;
    grid.querySelectorAll('[data-px-filter]').forEach(function (b) {
      b.classList.toggle('px-filter--active', b === btn);
    });
    const items = grid.querySelectorAll('[data-px-categories]');
    let shown = 0;
    items.forEach(function (it) {
      const cats = (it.getAttribute('data-px-categories') || '').toLowerCase().split(',').map(function (s) { return s.trim(); });
      const visible = filter === 'all' || cats.includes(filter);
      it.style.display = visible ? '' : 'none';
      if (visible) shown += 1;
    });
    const count = grid.querySelector('[data-px-count]');
    if (count) count.textContent = shown + (shown === 1 ? ' protocol' : ' protocols');
  });

  // ── Atelier cart drawer (delegates to Dawn cart-drawer custom element) ──
  // Atelier sections use class .ah__icon[data-atelier-cart] for the cart button.
  // Dawn already implements <cart-drawer> custom element; we just open it.
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-atelier-cart]');
    if (!trigger) return;
    e.preventDefault();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(trigger);
    } else {
      // Fallback: send user to /cart
      window.location.href = '/cart';
    }
  });

  // ── Candidacy modal (peptide products) ───────────────────────────────
  // Markup: <a data-atelier-candidacy href="https://calendly.com/…">Begin candidacy review</a>
  // Opens Calendly popup if available, otherwise navigates to the href.
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-atelier-candidacy]');
    if (!trigger) return;
    if (window.Calendly && trigger.href) {
      e.preventDefault();
      window.Calendly.initPopupWidget({ url: trigger.href });
    }
  });
})();
